import { Api } from 'src/api';
import { httpConfig } from 'src/lib/modules/http';

export interface PendingPurchaseEvent {
  id: number;
  event_type: 'recurring_payment' | 'initial_purchase';
  event_data: {
    transaction_id: string;
    value: number;
    currency: string;
    billing_interval: string;
    items: Array<{
      item_id: string;
      item_name: string;
      currency: string;
      price: number;
      quantity: number;
      discount?: number;
      coupon?: string;
      billing_interval: string;
    }>;
    total_price: number;
    total_recurring_price: number;
    customer_ltv: number;
    customer_type: 'NEW' | 'OLD';
    user_properties: Record<string, any>;
    coupon?: string;
    payment_type?: string;
  };
  created_at: string;
}

export interface PendingEventsResponse {
  events: PendingPurchaseEvent[];
}

const baseUrl = `${httpConfig.options.baseURL}/purchase-events`;

export const purchaseEventApi = {
  /**
   * Atomically claim and get pending events
   * Prevents race conditions from multiple tabs
   */
  claimAndGetPendingEvents: async (): Promise<PendingEventsResponse> => {
    // Axios interceptor already unwraps response.data
    return Api.http.post(`${baseUrl}/claim-and-get-pending`) as unknown as PendingEventsResponse;
  },

  /**
   * Mark events as successfully processed
   */
  markProcessed: async (eventIds: number[]): Promise<void> => {
    await Api.http.post(`${baseUrl}/mark-processed`, { event_ids: eventIds });
  },
};
